import { Alert, Flex } from '@percent/lemonade';
import { useTranslation } from 'react-i18next';
import { ErrorAlertProps } from './ErrorAlert.types';

export const ErrorAlert = ({ message }: ErrorAlertProps) => {
  const { t } = useTranslation();

  if (!message) return null;

  return (
    <Flex mb={24}>
      <Alert variant="error" title={t('typography.error.title')}>
        {message}
      </Alert>
    </Flex>
  );
};
